<span *ngIf="statusLabel" class="status-pill" [ngClass]="'status-pill--' + status">{{ statusLabel }}</span>
